export const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'var(--textIconColor)' : 'white', // change background color of selected option
      ":hover": {
          backgroundColor :"var(--lightdarkBGTable)",
          cursor:"pointer",
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }),
    input: (provided) => ({
      ...provided,
      color: 'var(--layoutTextColor) !important'
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--layoutBackground) !important',
      color: 'var(--layoutTextColor) !important',
      zIndex: "1000"
    }),
  };

  export const selectDisabled ={
  control: (base, state) => ({
    ...base,
    // color:state.isDisabled ? "var(--TextDisabled) !important":base.backgroundColor,
    color:"#000 !important",
    backgroundColor:state.isDisabled ? "var(--TextDisabled) !important":base.backgroundColor,
    border:" 1px solid #d3d1ce !important",
    borderRadius:"1px",
    height: 'auto',
    maxHeight: '100px',
    minHeight: 30,
  }
),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? 'rgb(161, 159, 157) !important' : "var(--layoutTextColor) !important",
  }),
  input: (base) => ({
    ...base,
    color: "var(--layoutTextColor) !important",
  }),
}

